export const version = "ethers/5.6.8";
